export const adminRole = "Admin";
export const ownerRole = "Owner";
